import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// components
import Button3d from '../../../../components/ButtonWrapper/components/Button3d';
import Chat from '../../../../components/Chat';
import LastActions from '../../../../components/LastActions';

const CommCenterProjects = () => {
    const [tabState, setTabState] = useState('lastActions')

    return (
        <div className="appCommCenter">
            <div className="appWorkbenchPanel commCenterPanel">
                <Button3d
                    changeFn={() => setTabState('lastActions')}
                    name="lastActions"
                    checked={tabState === 'lastActions'}>
                    {__('Prossime Azioni', 'soundbetween')}
                </Button3d>
                <Button3d
                    changeFn={() => setTabState('chat')}
                    name="chat"
                    checked={tabState === 'chat'}>
                    {__('Communicazioni', 'soundbetween')}
                </Button3d>
            </div>
            <div className="appDashboard__workbench">
                {tabState === 'lastActions' ? <LastActions/> : <Chat type="CUSTOMER"/>}
            </div>
        </div>
    )
}

export default CommCenterProjects;